export const typeOfStructureOptionsDialog = 'typeOfStructureOptionsDialog';
